import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateVariableInputWrapper = styled.span({
	marginTop: token('space.negative.150'),
	marginBottom: token('space.200'),
	paddingBottom: token('space.025'),
	display: 'inline-block',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateVariableNameWrapper = styled.span({
	padding: `${token('space.025')} 5px`,
	backgroundColor: token('color.background.accent.blue.subtlest'),
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: `${token('radius.small', '3px')} 0 0 ${token('radius.small', '3px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateVariableName = styled.span({
	wordBreak: 'break-all',
	color: token('color.text'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontWeight: 'initial',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateVariableType = styled.span({
	color: token('color.text.subtlest'),
	padding: `${token('space.025')} 5px`,
	backgroundColor: token('color.background.accent.blue.subtlest'),
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: `0 ${token('radius.small', '3px')} ${token('radius.small', '3px')} 0`,
	wordBreak: 'break-all',
});

// TemplateVariableInput
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateVariableInputFieldWrapper = styled.span({
	display: 'inline-block',
	maxWidth: '100%',
	whiteSpace: 'initial',
});
// textareas push the rest of the content down when inline
// so it needs extra styling
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateVariableTextareaInputFieldWrapper = styled.span({
	display: 'inline-block',
	maxWidth: '100%',
	position: 'relative',
	verticalAlign: 'top',
});

// TemplateVariableInputComponent
// atlaskit buttons text overlaps the popper dropdown
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ButtonStyle = styled.span({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& span': {
		position: 'unset',
	},
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DropDownInputWrapper = styled.span({
	marginLeft: token('space.025'),
});
